import template from './sw-cms-el-preview-jga-revocation-button.html.twig';

export default {
    template,
};
